import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { DISTRIBUTION_METRICS_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  data: FieldValues
}

const mutateUploadExcelMetrics = async ({ data }: mutateProps) => {
  return await axiosAuth.post(
    `${DISTRIBUTION_METRICS_API(data?.communityId)}/weighing-factor/upload`,
    data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useUploadExcelMetricsMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUploadExcelMetrics,
    ...queryParams,
  });

export default useUploadExcelMetricsMutation;
